import { FunctionComponent } from 'preact';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { Container } from './ListView.styles';
import { ListItemCard } from '../Cards/ListItemCard';
import { Stack } from '../../../../../Stack';
import { MobileCard } from '../Cards/MobileCard';
import { Card } from '../../models';
import { usePTPConfigContext } from '../../../../../../GlobalConfig.context';

interface ListViewProps {
  cards: Card[];
  spaceBetween?: number;
}

const ListView: FunctionComponent<ListViewProps> = ({ cards = [] }) => {
  const { isMobile } = useDetectDevice();
  const PTPConfig = usePTPConfigContext();
  const lineItemConfig = PTPConfig?.lineItem;
  const { productDescription: productDescriptionConfig } = lineItemConfig;
  const showDetailButton =
    productDescriptionConfig.isShow || productDescriptionConfig.showUrl;
  return (
    <Container isShowScroll={cards.length > 3} isMobile={isMobile}>
      <Stack gap={8} direction="column" align="center" justify="center">
        {cards.map((card) =>
          isMobile ? (
            <MobileCard card={card.data} showDetailButton={showDetailButton} />
          ) : (
            <ListItemCard
              card={card.data}
              showDetailButton={showDetailButton}
            />
          ),
        )}
      </Stack>
    </Container>
  );
};

export { ListView };
